const firebaseConfig = {
  apiKey: "AIzaSyChlg-dfUczxyh3qc4It2MeShjzbbCiWSM",
  authDomain: "medilane-pharmacy.firebaseapp.com",
  projectId: "medilane-pharmacy",
  storageBucket: "medilane-pharmacy.appspot.com",
  messagingSenderId: "442276105087",
  appId: "1:442276105087:web:c7b3e14b9917b6a8b3a84a",
};
export default firebaseConfig;
